import styled from "styled-components";

export const DashboardContainer = styled.div`
  color: #2b3445;
  padding: 2rem;
  background-color: #f6f9fc;
`;

export const DashboardHeading = styled.div`
  color: #2b3445;
  font-size: x-large;
  font-weight: 700;
  margin: 0 0 1rem;
`;

export const SearchContainer = styled.div`
  width: 40%;
  align-items: center;
  background-color: #ffffff;
  border-radius: 8px;
  color: #7d879c;
  display: flex;
  font-weight: 500;
  padding: 8px 16px;
`;

export const SearchBox = styled.input`
  color: #7d879c;
  font-size: 16px;
  font-weight: 500;
  width: 90%;
  padding: 4px 0px 5px;
  border: none;
  outline: none;
`;

export const SearchIconDiv = styled.div`
  color: #7d879c;
  fill: #7d879c;
  margin: 0px 3px 0px 0px;
  padding-top: 2px;
`;

export const MainContainerDiv = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgb(3 0 71 / 25%);
  color: #ffffff;
  font-size: 14px;
  padding: 1rem;
`;
export const MainContainerTodayDiv = styled.div`
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgb(3 0 71 / 25%);
  color: #ffffff;
  font-size: 14px;
  padding: 1rem;
  @media (max-width: 767px) {
    flex-direction: column;
  }
`;

export const MainContainerHeading = styled.h6`
  color: #4e97fd;
  font-size: 16px;
  font-weight: 600;
  margin: 0px 0px 8px;
`;

export const CurrentCount = styled.h3`
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
  line-height: 30px;
  margin: 0px 0px 2.4px;
`;

export const StatusContainer = styled.div`
  display: grid;
  align-items: center;
  @media (max-width: 768px) {
  }
`;

export const ActiveStatus = styled.div`
  max-width: 5rem;
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  height: 24px;
  border-radius: 16px;
  white-space: nowrap;
  cursor: default;
  outline: 0px;
  text-decoration: none;
  border: 0px;
  vertical-align: middle;
  box-sizing: border-box;
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  color: rgb(11, 119, 36);
  background-color: rgb(231, 249, 237);
  cursor: pointer;

  @media (max-width: 768px) {
  }
`;

export const InactiveStatus = styled.div`
  max-width: 5rem;
  display: inline-flex;
  -webkit-box-align: center;
  align-items: center;
  -webkit-box-pack: center;
  justify-content: center;
  height: 24px;
  border-radius: 16px;
  white-space: nowrap;
  cursor: default;
  outline: 0px;
  text-decoration: none;
  border: 0px;
  vertical-align: middle;
  box-sizing: border-box;
  padding: 0.25rem 0.5rem;
  font-size: 14px;
  color: rgb(255, 41, 41);
  background-color: rgb(255, 234, 234);
  cursor: pointer;

  @media (max-width: 768px) {
  }
`;
